export default __webpack_public_path__ + "static/media/Lydia.16645c5b.png";